import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import isEmpty from 'lodash/isEmpty'

import useInterval from 'hooks/useInterval'
import Layout from 'containers/Layout'
import AtractLoop from 'components/AtractLoop'
import RevenueCenterOrders from 'containers/RevenueCenterOrders'
import { getDoneOrders, getPendingOrders, getOrderWindowNames } from 'store/Orders/selector'
import { getCurrentRevenueCenter } from 'store/RevenueCenters/selector'
import { getMessage, getLogo } from 'store/Assets/selector'
import { fetchRevenueCenterOrders } from 'store/Orders/actions'
import { fetchRevenueCenters } from 'store/RevenueCenters/actions'
import { toggleAppState } from 'store/AppState/actions'

const RELOAD_ORDERS_PERIOD = 15000

export const Orders = ({
  currentRevenueCenter,
  ordersDone,
  ordersPending,
  orderWindowNames,
  match,
  fetchRevenueCenterOrders,
  fetchRevenueCenters,
  toggleAppState,
  message,
  logo,
}) => {
  useEffect(() => {
    fetchRevenueCenters()
    fetchRevenueCenterOrders(match.params.id)
    toggleAppState({ rvcUuid: match.params.id })
  }, [])

  useInterval(() => {
    fetchRevenueCenterOrders(match.params.id)
  }, RELOAD_ORDERS_PERIOD)

  return (
    <>
      {isEmpty(ordersDone) && isEmpty(ordersPending) ? (
        <AtractLoop logo={logo} message={message} />
      ) : (
        <Layout logo={logo} message={message}>
          <RevenueCenterOrders
            currentRevenueCenterName={currentRevenueCenter?.name ?? ''}
            ordersDone={ordersDone}
            ordersPending={ordersPending}
            orderWindowNames={orderWindowNames}
          />
        </Layout>
      )}
    </>
  )
}

Orders.propTypes = {
  fetchRevenueCenterOrders: PropTypes.func,
  fetchRevenueCenters: PropTypes.func,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
  currentRevenueCenter: PropTypes.shape({
    name: PropTypes.string,
  }),
  orderWindowNames: PropTypes.object,
  ordersDone: PropTypes.array,
  ordersPending: PropTypes.array,
  toggleAppState: PropTypes.func,
  message: PropTypes.string,
  logo: PropTypes.string,
}

const mapStateToProps = (state, ownProps) => ({
  currentRevenueCenter: getCurrentRevenueCenter(state, ownProps.match.params.id),
  ordersDone: getDoneOrders(state),
  ordersPending: getPendingOrders(state),
  orderWindowNames: getOrderWindowNames(state),
  message: getMessage(state),
  logo: getLogo(state),
})

const mapDispatchToProps = {
  fetchRevenueCenterOrders,
  fetchRevenueCenters,
  toggleAppState,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Orders)
